export var layoutVariables = function layoutVariables() {
  return {};
};